export enum UiPlatformStatusMarkerStateEnum {
  waiting = 'waiting',
  inProgress = 'in_progress',
  done = 'done',
  verification = 'verification',
  interactionNeeded = 'interaction_needed',
  verified = 'verified',
  ready = 'ready',
  notReady = 'not_ready'
}
